// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// eslint-disable-next-line no-undef
export default require.context('..', true, /\.page\.tsx$/, 'lazy');
